import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { SERVER_URL } from "../initalState"; // Note: Fix typo "initalState" to "initialState"

export const vehiclesApi = createApi({
  reducerPath: "vehicles",
  baseQuery: fetchBaseQuery({
    // baseUrl: `${SERVER_URL}/qiktrack`,
    baseUrl: `${SERVER_URL}/qiktrack`,
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  tagTypes: ["Vehicles"],
  endpoints: (builder) => ({
    getVehicles: builder.query({
      query: ({ companyID, page, limit, search }) => {
        const params = {};
        if (page !== undefined && page !== "") params.page = page;
        if (limit !== undefined && limit !== "") params.limit = limit;
        if (search !== undefined && search !== "") params.search = search;
        return {
          url: `/getCompanyId-Vehicle/${companyID}`,
          method: "GET",
          params: Object.keys(params).length > 0 ? params : undefined,
        };
      },
      providesTags: ["Vehicles"],
      keepUnusedDataFor: 0,
    }),
    get_verification: builder.query({
      query: ({ companyID, page, limit, search }) => {
        // Create params object, only including non-empty values
        const params = {};
        if (page !== undefined && page !== "") params.page = page;
        if (limit !== undefined && limit !== "") params.limit = limit;
        if (search !== undefined && search !== "") params.search = search;

        console.log(params);
        return {
          url: `/get-verification`,
          method: "GET",
          params: Object.keys(params).length > 0 ? params : undefined,
        };
      },
      providesTags: ["Vehicles"], // Tag for cache invalidation
      keepUnusedDataFor: 0, // Add this to match get_bank_account behavior
    }),
    get_apihit: builder.query({
      query: ({ companyID, page, limit, search }) => {
        // Create params object, only including non-empty values
        const params = {};
        if (page !== undefined && page !== "") params.page = page;
        if (limit !== undefined && limit !== "") params.limit = limit;
        if (search !== undefined && search !== "") params.search = search;

        console.log(params);
        return {
          url: `/get-apihit`,
          method: "GET",
          params: Object.keys(params).length > 0 ? params : undefined,
        };
      },
      providesTags: ["Vehicles"], // Tag for cache invalidation
      keepUnusedDataFor: 0, // Add this to match get_bank_account behavior
    }),
    get_company: builder.query({
      query: ({ id, page, limit, search }) => {
        const params = {};
        if (page !== undefined && page !== "") params.page = page;
        if (limit !== undefined && limit !== "") params.limit = limit;
        if (search !== undefined && search !== "") params.search = search;
        if (id !== undefined && id !== "") params._id = id;
        return {
          url: `/get-company`,
          method: "GET",
          params: Object.keys(params).length > 0 ? params : undefined,
        };
      },
      providesTags: ["Vehicles"],
      keepUnusedDataFor: 0,
    }),
    get_company_by_id: builder.query({
      query: ({ id }) => ({
        url: `/Company/${id}`,
        method: "GET",
      }),
      providesTags: ["Vehicles"],
      keepUnusedDataFor: 0,
    }),
    get_order: builder.query({
      query: ({ companyID, page, limit, search }) => {
        // Create params object, only including non-empty values
        const params = {};
        if (page !== undefined && page !== "") params.page = page;
        if (limit !== undefined && limit !== "") params.limit = limit;
        if (search !== undefined && search !== "") params.search = search;

        console.log(params);
        return {
          url: `/get-order`,
          method: "GET",
          params: Object.keys(params).length > 0 ? params : undefined,
        };
      },
      providesTags: ["Vehicles"], // Tag for cache invalidation
      keepUnusedDataFor: 0, // Add this to match get_bank_account behavior
    }),
    // Add a vehicle

    addCompany: builder.mutation({
      query: (data) => {
        console.log(data);
        return {
          url: "/new-company",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["Vehicles"], // Invalidate cache on mutation
    }),
    vehicle_status_refresh: builder.mutation({
      query: (data) => {
        console.log(data);
        return {
          url: "/vehicle-status",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["Vehicles"], // Invalidate cache on mutation
    }),
    updateCompany: builder.mutation({
      query: (data) => {
        return {
          url: `/update-company/${data?._id}`,
          method: "PUT",
          body: data,
        };
      },
      invalidatesTags: ["Vehicles"], // Invalidate cache on mutation
    }),
    deleteCompany: builder.mutation({
      query: ({ companyID, vehicleNumber, id }) => ({
        url: `/delete-company/${id}`,
        method: "DELETE",
        body: { company_id: companyID, vehiclenumber: vehicleNumber },
      }),
      invalidatesTags: ["Vehicles"], // Invalidate cache on mutation
    }),
    addVehicle: builder.mutation({
      query: (data) => {
        console.log(data);
        return {
          url: "/create-vehicle",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["Vehicles"], // Invalidate cache on mutation
    }),
    updateVehicle: builder.mutation({
      query: (data) => {
        return {
          url: `/update-vehicle/${data?._id}`,
          method: "PUT",
          body: data,
        };
      },
      invalidatesTags: ["Vehicles"], // Invalidate cache on mutation
    }),

    deleteVehicle: builder.mutation({
      query: ({ companyID, vehicleNumber, id }) => {
        return {
          url: `/delete-vehicle/${id}`,
          method: "DELETE",
          body: { company_id: companyID, vehiclenumber: vehicleNumber },
        };
      },
      invalidatesTags: ["Vehicles"], // Invalidate cache on mutation
    }),
  }),
});

export const {
  useGetVehiclesQuery,
  useAddVehicleMutation,
  useUpdateVehicleMutation,
  useDeleteVehicleMutation,
  useGet_verificationQuery,
  useGet_orderQuery,
  useGet_companyQuery,
  useGet_company_by_idQuery,
  useUpdateCompanyMutation,
  useAddCompanyMutation,
  useDeleteCompanyMutation,
  useVehicle_status_refreshMutation,
  useGet_apihitQuery
} = vehiclesApi;
